import { createNS } from "@ontologies/core";

export default {
  ns: createNS("http://dbpedia.org/property/"),
};
